import React from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  useTheme,
  Button,
  useMediaQuery,
  Chip,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useDispatch } from "react-redux";
import { removeAuth } from "../../store/slices/authSlice";
import WorkItemCalendarSync from "../workitem-calendar-sync/WorkItemCalendarSync";

interface AppHeaderProps {
  onMenuClick: () => void;
  miniMode: boolean;
  toggleMiniMode: () => void;
}

export function AppHeader({
  onMenuClick,
  miniMode,
  toggleMiniMode,
}: AppHeaderProps) {
  const theme = useTheme();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const logout = () => {
    dispatch(removeAuth());
  };

  // Check if we're in test environment
  const isTestEnvironment = import.meta.env.VITE_NAV_API_URL?.includes('api-t.kraftsamling.se') || 
                            import.meta.env.VITE_NAV_API_URL?.includes('localhost');
  return (
    <AppBar
      position="fixed"
      sx={{
        zIndex: theme.zIndex.drawer + 1,
        backgroundColor: "white",
        color: "text.primary",
        boxShadow: "0px 1px 3px rgba(0,0,0,0.1)",
      }}
    >
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="toggle menu"
          edge="start"
          onClick={isMobile ? onMenuClick : toggleMiniMode}
          sx={{ mr: 2 }}
        >
          {isMobile ? (
            <MenuIcon />
          ) : miniMode ? (
            <ChevronRightIcon />
          ) : (
            <ChevronLeftIcon />
          )}
        </IconButton>
        <Box sx={{ flexGrow: 1, display: "flex", alignItems: "center", gap: 2 }}>
          <Typography variant="h6" noWrap component="div">
            Företagsportalen
          </Typography>
          {isTestEnvironment && (
            <Chip
              label="TEST"
              size="small"
              sx={{
                bgcolor: "warning.main",
                color: "warning.contrastText",
                fontWeight: "bold",
                fontSize: "0.7rem",
                height: 24,
              }}
            />
          )}
        </Box>
        <WorkItemCalendarSync />
        <Button onClick={logout} sx={{ color: "text.primary" }}>
          Logga ut
        </Button>
      </Toolbar>
      
    </AppBar>
  );
}
